import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import Table from './TableStyle';
import moment from 'moment';
import Modal from './ModalInfo';
import Box from '../../StoragePage/components/BoxSetting';
import AddLock from '../../StoragePage/components/AddLock';
import { ReactComponent as WarnRedIcon } from '../../../images/warn_red.svg';
import { ReactComponent as NotAuthIcon } from '../../../images/not_auth.svg';
import { ReactComponent as WarnYellowIcon } from '../../../images/warn_yellow.svg';
import { ReactComponent as Key } from '../../../images/key_green.svg';

function List({
  users,
  updateData,
  getBoxes,
  boxes,
  loadingBox,
  getUsers,
  updateBox,
  updateDevice,
  locks,
  getDevices,
  postBox,
  loadingDevice,
}) {
  const { t } = useTranslation();
  const [dataCol, setdataCol] = useState([]);
  const [visible, setVisible] = useState(false);
  const [user, setUser] = useState(null);
  const [box, setBox] = useState(false);
  const [userId, setUserId] = useState(null);
  const [visibleBox, setVisibleBox] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [boxId, setBoxId] = useState(null);

  const columns = [
    {
      title: '',
      dataIndex: 'icons',
      key: 'icons',
      render: (text, record) => {
        return <div className="item-row">{record.icons}</div>;
      },
      width: '5%',
    },
    {
      title: t('customer'),
      dataIndex: 'customer',
      key: 'customer',
      render: (text, record) => {
        return (
          <div className="item-row">
            <span
              onClick={() => {
                openUserModal(record.customer);
              }}
              className="user"
            >
              {record.customer.first_name === '' &&
              record.customer.last_name === ''
                ? record.customer.email
                : `${record.customer.first_name}  ${record.customer.last_name}`}
            </span>
            <span className="phone">{record.customer.phone}</span>
          </div>
        );
      },
      sorter: (a, b) =>
        a.customer.first_name.localeCompare(b.customer.first_name),
      width: '18%',
    },
    {
      title: t('boxesInRent'),
      dataIndex: 'boxesInRent',
      key: 'boxesInRent',
      render: (text, record) => {
        return <div className="item-row">{record.boxesInRent}</div>;
      },
      sorter: (a, b) => Number(a.boxesInRent) - Number(b.boxesInRent),
      width: '20%',
    },
    {
      title: t('allRent'),
      dataIndex: 'allRent',
      key: 'allRent',
      width: '20%',
      render: (text, record) => {
        return <div className="item-row">{record.allRent}</div>;
      },
      sorter: (a, b) => Number(a.allRent) - Number(b.allRent),
    },
    {
      title: t('expiration'),
      dataIndex: 'expiration',
      key: 'expiration',
      width: '20%',
      render: (text, record) => {
        return <div className="item-row">{record.expiration}</div>;
      },
      sorter: (a, b) => Number(a.expiration) - Number(b.expiration),
    },
    {
      title: t('lastActive'),
      dataIndex: 'lastActive',
      key: 'lastActive',
      render: (text, record) => {
        return <div className="item-row">{record.lastActive}</div>;
      },
      width: '14%',
      sorter: (a, b) => {
        let date1 = moment(a.lastActive, 'DD/MM/YYYY').format(
          'YYYY-MM-DD[T]HH:mm:ss',
        );
        let date2 = moment(b.lastActive, 'DD/MM/YYYY').format(
          'YYYY-MM-DD[T]HH:mm:ss',
        );
        return moment(date1).unix() - moment(date2).unix();
      },
    },
  ];

  const openUserModal = (user) => {
    setVisible(!visible);
    setUser(user);
    setUserId(user.id);
  };

  useMemo(() => {
    const dataForTable = map(users, (item, index) => {
      return {
        key: index,
        icons:
          item.boxes_expired !== 0 ? (
            <WarnRedIcon className="text-14" />
          ) : item.soon ? (
            <WarnYellowIcon />
          ) : item.authorized ? (
            <Key />
          ) : (
            <NotAuthIcon />
          ),
        customer: item,
        boxesInRent: item.boxes_active,
        allRent: item.boxes_total,
        expiration: item.boxes_expired,
        lastActive: moment(item.last_login).format('DD.MM.YYYY'),
      };
    });
    setdataCol(dataForTable);
    if (user) {
      const newData = filter(users, (item) => {
        return item.id === user.id;
      });
      setUser(newData[0]);
    }
  }, [users]);

  useMemo(() => {
    if (box) {
      const sorted = filter(boxes, (item) => {
        return item.id === box.id;
      });
      setBox(sorted[0]);
    }
    if (!box && boxId && visibleBox) {
      const sorted = filter(boxes, (item) => {
        return item.id === boxId;
      });
      setBox(sorted[0]);
    }
  }, [boxes]);

  return (
    <>
      {dataCol.length !== 0 ? (
        <Table
          className="w-full"
          pagination={false}
          columns={columns}
          showSorterTooltip={false}
          dataSource={dataCol}
        />
      ) : (
        <Empty className="mt-20" />
      )}
      {user ? (
        <Modal
          setUser={setUser}
          loadingBox={loadingBox}
          boxes={boxes}
          getBoxes={getBoxes}
          updateData={updateData}
          user={user}
          users={users}
          getUsers={getUsers}
          visible={visible}
          setVisible={setVisible}
          updateDevice={updateDevice}
          updateBox={updateBox}
          locks={locks}
          getDevices={getDevices}
          postBox={postBox}
          setBox={setBox}
          setVisibleAdd={setVisibleAdd}
          visibleAdd={visibleAdd}
          setVisibleBox={setVisibleBox}
          visibleBox={visibleBox}
        />
      ) : null}
      {box &&
        (box.device ? (
          <Box
            source="customers"
            data={box}
            setUser={setUser}
            setBox={setBox}
            visible={visibleBox}
            setVisible={setVisibleBox}
            allUsers={users}
            boxes={boxes}
            storageId={box.section.warehouse_id}
            updateDevice={updateDevice}
            updateBox={updateBox}
            getBoxes={getBoxes}
            cliendId={userId}
            setUserVisible={setVisible}
            userVisible={visible}
          />
        ) : (
          <AddLock
            source="customers"
            sectionName={box.section.name}
            sectionId={box.section.id}
            locks={locks}
            visible={visibleAdd}
            setVisible={setVisibleAdd}
            postBox={postBox}
            storageId={box.section.warehouse.id}
            getBoxes={getBoxes}
            getDevices={getDevices}
            box={box}
            boxName={box.name}
            updateDevice={updateDevice}
            updateBox={updateBox}
            setBoxId={setBoxId}
            setVisibleSetting={setVisibleBox}
            visibleSetting={visibleBox}
            setBoxNotLock={setBox}
            visibleCustomers={visible}
            setVisibleCustomers={setVisible}
            user={user}
            setUser={setUser}
            loadingDevice={loadingDevice}
            cliendId={userId}
          />
        ))}
    </>
  );
}

List.propTypes = {};

export default List;
